import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-pagetitle',
  templateUrl: './pagetitle.component.html',
  styleUrls: ['./pagetitle.component.scss']
})
export class PagetitleComponent implements OnInit {

  @Input() breadcrumbItems:any;
  @Input() title: any;
  @Input() actionButton?: {
    label: string;
    onClick: () => void;
  };

  constructor() { }

  ngOnInit(): void {
  }

}
